import {
  HomefieldIconsLibraryService,
  homefieldIconArrowTrendFlatOutline,
  homefieldIconChevronLeftOutline,
  homefieldIconChevronRightOutline,
  homefieldIconListTuneOutline,
  homefieldIconNotificationAddFill,
} from '@dsg-tech/homefield-angular-icons';
import { NgModule } from '@angular/core';

/**
 * Any homefield icon needed within the home app should be loaded and registered here. This module will then be imported into the app.module.ts.
 * Loading the homefield icons prior to the lazy-loaded component modules is necessary as per the homefield documentation.
 * The HomefieldIconLibraryModule should be loaded into each module that requires a subset of the icons registered below. See launch-calendar.module.ts as an example.
 */
@NgModule()
export class AppHomefieldIconsModule {
  constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
    homefieldIconsLibraryService.registerIcons([
      homefieldIconChevronRightOutline,
      homefieldIconChevronLeftOutline,
      homefieldIconNotificationAddFill,
      homefieldIconArrowTrendFlatOutline,
      homefieldIconListTuneOutline,
    ]);
  }
}
